<template>
  <div>
<!--    <div v-if="isGift" class="container-fluid d-flex justify-content-between m-3">-->
<!--      <button class="btn bg-white text-primary shadow bg-white" style="border-radius: 5px" type="button"><span-->
<!--          class="material-icons md-36">menu</span> <span>{{ $t("message.login") }}</span></button>-->
<!--      <button class="btn bg-white text-primary shadow p-2 bg-white mr-5" style="border-radius: 5px" type="button"><span-->
<!--          class="material-icons md-36">card_giftcard</span> <span>{{ $t("message.checkGiftCardBalance") }}</span>-->
<!--      </button>-->
<!--    </div>-->

    <div
        v-if="!isWC() && store && currentStoreDoc"
        :style="{ 'background-image': 'url(' + store.ProfileImage + ')' }"
        class="banner text-white position-relative"
    >
      <div class="company-details">
        <router-link
            v-if="getLogo && showLogo && !isRolldStore()"
            :class="isGift && 'd-flex align-items-center justify-content-center'"
            :to="geyHomePageUrl"
        >

          <div v-if="isGift"
               class="rounded-circle text-center d-flex align-items-center justify-content-center mb-4 p-2"
               style="width: 10vw; height: 10vw;">
            <img :src="getLogo" alt="logo" style="width: 80%;" @error="showLogoError"/>
          </div>
          <img v-else :src="getLogo" alt="logo" @error="showLogoError"/>
        </router-link>
        <h2 v-show="store.StoreTitle">{{ store.StoreTitle }}</h2>
        <h5 v-show="!isGift" class="text-center">
          {{ store.Name }}
          <router-link
              v-if="showChangeStore"
              to="/"
          >
            <span class="change-store">[{{ $t("message.changeStore") }}]</span>
          </router-link>
        </h5>
        <h5 v-if="store.Location">
          {{ store.Location.Address }}
          {{
            (store.Location.Suburb || "") +
            " " +
            (store.Location.State || "") +
            " " +
            (store.Location.Postcode || "")
          }}
        </h5>

        <div v-if="!isGift">
          <h5 v-if="store.OfficePhone">{{ store.OfficePhone }}</h5>
          <div v-if="getloadedMenu">
            <h6 v-if="opening && (opening.openTime || opening.closeTime)">
              {{ $t("message.open") }}
              <span>{{ opening.openTime }}</span>
              {{ $t("message.toName") }}
              <span>{{ opening.closeTime }}</span>
            </h6>
            <h6 v-else-if="!isEnablePreOrder">{{ $t("message.closedToday") }}</h6>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {
  operatingHours,
  getCurrentDate,
} from "../../../api/helpers/datetimeHelper.js";
import { mapGetters } from "vuex";
export default {
  name: "ShopHeader",
  props: {
    storeId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showLogo: true,
      store: {},
    };
  },
  mounted() {
    this.store = this.selectedCompany
      ? this.selectedCompany
      : this.currentStoreDoc;
  },
  watch: {
    selectedCompany() {
      this.store = this.selectedCompany
        ? this.selectedCompany
        : this.currentStoreDoc;
    },
    currentStoreDoc() {
      this.store = this.selectedCompany
        ? this.selectedCompany
        : this.currentStoreDoc;
    },
  },
  computed: {
    ...mapGetters([
      "isGift",
      "getloadedMenu",
      "currentStoreDoc",
      "selectedCompany",
      "hqDoc",
    ]),
    opening() {
      if (this.store.OperatingHours) {
        var now = getCurrentDate(this.store.TimezoneIanaFormat);
        return operatingHours(this.store.BlackoutDates, now, this.store.OperatingHours);
      } else {
        return null;
      }
    },
    geyHomePageUrl() {
      return this.isGift
        ? "/store/" + this.currentStoreDoc.ID + "/giftcards"
        : "/store/" + this.currentStoreDoc.ID;
    },
    isEnablePreOrder() {
      return (
        this.selectedCompany.IsInOperation &&
        (this.selectedCompany.EnablePreoderForDelivery ||
          this.selectedCompany.EnablePreoderForPickup)
      );
    },
    getLogo() {
      if (!this.isRolldStore()) {
        return this.currentStoreDoc.Logo;
      } else {
        return this.hqDoc
          ? this.hqDoc.Logo
          : this.currentStoreDoc
          ? this.currentStoreDoc.Logo
          : "";
      }
    },
    showChangeStore() {
      return (!this.isGift || !this.isWC() || !this.isRootPath()) && this.isBranded();
    },
  },
  methods: {
    showLogoError() {
      this.showLogo = false;
    },
    isRootPath() {
      return location.pathname === "/";
    },
  },
};
</script>
